var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['user-layout-wrapper', _vm.device],attrs:{"id":"warehouseLayout"}},[_c('div',{staticClass:"content-box"},[_c('user-menu',{staticClass:"user-menu"})],1),_c('div',{staticClass:"container"},[_c('route-view'),_vm._m(0)],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('div',{staticClass:"copyright"},[_vm._v("\n        Copyright © MegaTechnology\n      ")])])
}]

export { render, staticRenderFns }